import { Button, message, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Outlet } from "react-router-dom";
import Filter from './../../../components/Filter';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useBasePath } from '../../../components/NavigatePath';
function Pharmacies() {
    const navigate = useNavigate();
    const API_URL = import.meta.env.VITE_API_URL;
    const [Pharmacies, setPharmacies] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [loading, setLoading] = useState(false);
    const accessToken = useSelector((state) => state.user.accessToken);
    const basePath = useBasePath();
    const pharmacyDetails = useSelector((state) => state.user.pharmacyDetails);
    const userId = useSelector((state) => state.user.user.roleDetails.id);
    const [filterDropdowns, setFilterDropdowns] = useState([
        {
            title: "Status",
            options: ["Active", "Inactive"],
        }

    ]);
    // Filters dropdown
    const [filterOptions, setFilterOptions] = useState({})
    const [selectedFilters, setSelectedFilters] = useState({ status: null, search: null });

    const handleAddBranch = (data) => {
        navigate(`/${basePath}/pharmacies/AddBranch/${data.id}`, { state: { data: data } });
    };
    const fetchPharmacies = async (page = 1, pageSize = 10, active = null, search = null) => {
        setLoading(true);
        try {
            let response;
            const queryParams = new URLSearchParams(
                userId === 4
                    ? { id: pharmacyDetails?.id } // Only send id for userId 4
                    : {
                        limit: pageSize,
                        page: page,
                        ...(active !== null && { active }),
                        ...(search && { search }),
                    }
            ).toString();

            if (userId == 4) {
                response = await axios.get(`${API_URL}pharmacies?${queryParams}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                console.log(response.data);
                // Ensure pharmaciesData is always an array
                const pharmaciesData = response.data ? [response.data.Pharmacy] : [];
                setPharmacies(pharmaciesData);
            } else {
                // Existing code for other users
                response = await axios.get(`${API_URL}pharmacies/get-pharmacies?${queryParams}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                const pharmaciesData = response.data.Pharmacies || [];
                const { totalCount } = response.data;
                setPharmacies(pharmaciesData);
                setPagination({
                    ...pagination,
                    current: page,
                    pageSize: pageSize,
                    total: totalCount,
                });
            }

        } catch (error) {
            console.error("Error fetching Pharmacies:", error);
            message.destroy();
            message.error('Failed to fetch Pharmacies');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (key, value) => {
        let updatedFilters = { ...selectedFilters };
        let errorMessageShown = false;

        if (key === "Status") {
            const status = value === "Active" ? true : value === "Inactive" ? false : null;
            updatedFilters.status = status;
        }

        if (key === "search") {
            let search = null;

            if (value && value.trim().length > 0) {
                const searchValue = value.trim();

                if (/\d/.test(searchValue)) {
                    message.destroy();
                    message.error("Search term must not contain numbers.");
                    errorMessageShown = true;
                } else if (searchValue.length > 4) {
                    search = searchValue;
                }
            }

            updatedFilters.search = search;
        }

        if (key === "") {
            fetchPharmacies();
            updatedFilters = {};
        }

        setSelectedFilters(updatedFilters);

        if (!errorMessageShown) {
            fetchPharmacies(1, pagination.pageSize, updatedFilters.status, updatedFilters.search);
        }
    };
    const handleTableChange = (newPagination) => {
        fetchPharmacies(newPagination.current, newPagination.pageSize, selectedFilters.status, selectedFilters.search);
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        }));
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`${API_URL}pharmacies/?id=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.status === 200) {
                fetchPharmacies()
                message.success("Pharmacy deleted successfully");
                message.destroy();
            }

        } catch (error) {
            console.error("Error deleting Pharmacy:", error);
            message.destroy();
            message.error("Failed to delete Pharmacy");
        }
    };
    useEffect(() => {
        fetchPharmacies(1, pagination.pageSize, selectedFilters.status, selectedFilters.search);
    }, [pagination.pageSize, selectedFilters]);

    useEffect(() => {
        fetchPharmacies(pagination.current, pagination.pageSize, selectedFilters.status, selectedFilters.search);
    }, [pagination.current]);

    let columns;
    if (userId == 4) {
        columns = [
            {
                title: <span>Pharmacy Name</span>,
                dataIndex: "name",
                key: "Pharmacy_Name",
            },
            {
                title: "Contact",
                dataIndex: "contactNumber",
                key: "Contact",
            },
            {
                title: "Profile",
                render: (text, row) => (
                    <div className="row-actions">
                        <Button
                            style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
                            onClick={() => handleViewPharmacies(row)}
                        >
                            View
                        </Button>
                    </div>
                ),
            },
            {
                title: "Add Branch",
                render: (text, row) => (
                    <Button
                        style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
                        onClick={() => handleAddBranch(row)}
                    >
                        + Add Branch
                    </Button>
                ),
            },
            {
                title: "Status",
                dataIndex: "active",
                render: (text, row) => (
                    <div className="flex">

                        <Button
                            disabled={row.active}
                            style={{
                                borderRadius: 0,
                                border: 0,
                                margin: 0,
                                backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
                                color: row.active ? "#FFFFFF" : "#123288",
                                cursor: row.active ? "not-allowed" : "pointer",
                            }}
                            onClick={() => handleStatusChange(row.id, true)}
                        >
                            Active
                        </Button>
                        <Button
                            disabled={!row.active}
                            style={{
                                borderRadius: 0,
                                margin: 0,
                                border: 0,
                                backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
                                color: row.active ? "#123288" : "#FFFFFF",
                                cursor: !row.active ? "not-allowed" : "pointer",
                            }}
                            onClick={() => handleStatusChange(row.id, false)}
                        >
                            Inactive
                        </Button>
                    </div>
                ),
            },

        ];
    } else {
        columns = [
            {
                title: <span>Pharmacy Name</span>,
                dataIndex: "name",
                key: "Pharmacy_Name",
            },
            {
                title: "Contact",
                dataIndex: "contactNumber",
                key: "Contact",
            },
            {
                title: "Profile",
                render: (text, row) => (
                    <div className="row-actions">
                        <Button
                            style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
                            onClick={() => handleViewPharmacies(row)}
                        >
                            View
                        </Button>
                    </div>
                ),
            },
            {
                title: "Add Branch",
                render: (text, row) => (
                    <Button
                        style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
                        onClick={() => handleAddBranch(row)}
                    >
                        + Add Branch
                    </Button>
                ),
            },
            {
                title: "Status",
                dataIndex: "active",
                render: (text, row) => (
                    <div className="flex">

                        <Button
                            disabled={row.active}
                            style={{
                                borderRadius: 0,
                                border: 0,
                                margin: 0,
                                backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
                                color: row.active ? "#FFFFFF" : "#123288",
                                cursor: row.active ? "not-allowed" : "pointer",
                            }}
                            onClick={() => handleStatusChange(row.id, true)}
                        >
                            Active
                        </Button>
                        <Button
                            disabled={!row.active}
                            style={{
                                borderRadius: 0,
                                margin: 0,
                                border: 0,
                                backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
                                color: row.active ? "#123288" : "#FFFFFF",
                                cursor: !row.active ? "not-allowed" : "pointer",
                            }}
                            onClick={() => handleStatusChange(row.id, false)}
                        >
                            Inactive
                        </Button>
                    </div>
                ),
            },

        ];
    }


    if (userId === 1) {
        columns.push({
            title: "Delete",
            key: "delete",
            render: (text, row) => (
                <Button
                    danger
                    style={{ borderRadius: 0, borderColor: "#FF4D4F", backgroundColor: "#FF4D4F", color: "#FFFFFF" }}
                    onClick={() => handleDelete(row.id)}
                >
                    Delete
                </Button>
            ),
        });
    }

    // View Pharmacy navigation
    const handleViewPharmacies = (data) => {
        navigate(`viewPharmacies/${data.id}`, { state: { data: data } });
    };

    // function to change status active or inactive
    const handleStatusChange = async (id, isActive) => {
        const status = isActive ? 1 : 0;
        try {
            const response = await axios.patch(`${API_URL}pharmacies?id=${id}`, { active: status },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.status === 200) {
                fetchPharmacies()
            }
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    useEffect(() => {
        // filter / make the api calls here

    }, [filterOptions])

    return (
        <>
            <div className=' space-y-5 '>
                {userId == 4 ? "" :
                    <Filter
                        filterOptions={filterOptions}
                        setFilterOptions={setFilterOptions}
                        addItemName='Add Pharmacy'
                        addItemUrl='AddPharmacy'
                        searchBarPlaceholder='Search Pharmacies'
                        dropdowns={filterDropdowns}
                        onFilterChange={handleFilterChange}
                    />}
                <Table
                    className="customTable"
                    style={{ backgroundColor: '#FFFFFF', padding: "10px" }}
                    columns={columns}
                    loading={loading}
                    dataSource={Pharmacies}
                    rowKey="id"
                    pagination={pagination}
                    onChange={handleTableChange}
                />
            </div >
            <Outlet />
        </>
    )
}

export default Pharmacies
